import type { BoxProps } from '@chakra-ui/react'
import { Box, Button, Grid, HStack, Icon, Text, useToast } from '@chakra-ui/react'
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { yupResolver } from '@hookform/resolvers/yup'
import { InputFormControl } from 'BrokerTsLib/src/components'
import type { SendResetPasswordLinkRequest } from 'BrokerTsLib/src/dtos'
import { useSendResetPasswordLink } from 'BrokerTsLib/src/hooks/useAccount'
import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import * as yup from 'yup'
import { useTranslationsContext } from '../../context/TranslationsContext'

export const SendResetPasswordLinkForm = (props: BoxProps) => {
    const { translate } = useTranslationsContext()
    const { mutateAsync } = useSendResetPasswordLink()
    const form = useForm<SendResetPasswordLinkRequest>({
        defaultValues: { userName: '' },
        resolver: yupResolver(yup.object({
            userName: yup.string()
                .required(translate('resetPassword.usernameRequired', 'Uživatelské jméno je povinné.'))
                .trim()
                .min(1, translate('resetPassword.usernameRequired', 'Uživatelské jméno je povinné.'))
        }))
    })
    const toast = useToast()
    const [sent, setSent] = useState(false)

    const { handleSubmit, control, formState: { isSubmitting, isValid } } = form

    const sendResetPasswordLink = (request: SendResetPasswordLinkRequest) => mutateAsync(request)
        .then(() => {
            toast({
                title: translate('resetPassword.linkSent', 'Odkaz pro reset hesla byl odeslán.'),
                status: 'success'
            })
            setSent(true)
        })
        .catch(() => {
            toast({
                title: translate('resetPassword.linkSentFailed', 'Odeslání odkazu pro reset hesla selhalo.'),
                status: 'error'
            })
        })

    return <FormProvider {...form}>
        <Box as="form" onSubmit={handleSubmit(sendResetPasswordLink)} {...props}>
            <Grid gap={4}>
                <InputFormControl isRequired label={translate('resetPassword.username', 'Uživatelské jméno')} name="userName" control={control} rules={{ required: true, minLength: 1 }}
                    w='100% !important'
                    autoComplete="username"
                    formControlVariant="fullWidth" />
                <Button colorScheme="primary" type="submit" size='lg' isLoading={isSubmitting} isDisabled={!isValid}>
                    <HStack gap={4}>
                        <Icon as={FontAwesomeIcon} icon={faPaperPlane} />
                        <Text color='inherit'>{sent ? translate('resetPassword.resendEmail', 'Odeslat e-mail znovu') : translate('resetPassword.sendEmail', 'Odeslat e-mail')}</Text>
                    </HStack>
                </Button>
            </Grid>
        </Box>
    </FormProvider>
}